<div class="form-field-wrapper">
  <div class="app-form-field">
    <mat-form-field appearance="outline">
      <mat-date-range-input
        [rangePicker]="picker"
        [formGroup]="getDateRangeGroup()"
        [min]="minDate"
      >
        <input
          matStartDate
          formControlName="start"
          [placeholder]="startPlaceholder()"
        />
        <input
          matEndDate
          formControlName="end"
          [placeholder]="endPlaceholder()"
        />
      </mat-date-range-input>

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <app-tooltip [tooltip]="hint()"></app-tooltip>
  </div>
  <app-form-error [control]="getControl()"></app-form-error>
</div>
